import { ArrowRightIcon, Tag } from '@lokalise/louis'
import type { Integrations } from '@lokalise/translation-api-schemas'
import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import type { AiConfigProjectWithLanguages } from '../../types/projects'
import { AiModelIcon } from '../AiModelIcon/AiModelIcon'
import { Card } from './components/Card/Card'
import styles from './KeysForLanguage.module.css'

export const KeysForLanguageContainer = ({ children }: PropsWithChildren) => (
  <div className={styles.outerContainer}>{children}</div>
)

export const KeysForLanguageBorderWrapper = ({ children }: PropsWithChildren) => (
  <div className={styles.borderWrapper}>{children}</div>
)

export const KeysForLanguageContents = ({ children }: PropsWithChildren) => (
  <div className={styles.container}>{children}</div>
)

type KeysForLanguageHeaderProps = { name: string; integration: Integrations }
export const KeysForLanguageHeader = ({ name, integration }: KeysForLanguageHeaderProps) => (
  <div className={styles.titleContainer}>
    <div className="flex gap-1">
      <Tag className={styles.statusTag}>Status</Tag>
      <div className={styles.integrationIconContainer}>
        <AiModelIcon integration={integration} size="14px" role="img" />
      </div>
    </div>
    <h4 className={clsx(styles.title, !name && styles.placeholder)}>
      {name || 'Select your profile name'}
    </h4>
  </div>
)

type KeysForLanguagesSourceCardProps = {
  sourceLanguage?: { name: string }
  highlighted?: boolean
}
export const KeysForLanguagesSourceCard = ({
  sourceLanguage,
  highlighted = false,
}: KeysForLanguagesSourceCardProps) => (
  <Card title="Source language" highlighted={highlighted}>
    {sourceLanguage ? sourceLanguage.name : 'Select'}
  </Card>
)

export const KeysForLanguagesSourceArrow = () => (
  <div className={styles.icon}>
    <ArrowRightIcon color="var(--lok-color-background-switch-marker-default)" size="16px" />
  </div>
)

export const KeysForLanguagesTargetLanguagesContainer = ({ children }: PropsWithChildren) => (
  <div className={styles.target}>{children}</div>
)

type KeysForLanguagesTargetLanguagesCardProps = {
  numberOfTargetLanguages: number
}
export const KeysForLanguagesTargetLanguagesCard = ({
  numberOfTargetLanguages,
}: KeysForLanguagesTargetLanguagesCardProps) => (
  <Card title="Target language">{numberOfTargetLanguages} target languages</Card>
)

type KeysForLanguagesProjectDetailsProps = {
  highlighted?: boolean
  projects?: AiConfigProjectWithLanguages[]
  hasProjectWarning?: (project: AiConfigProjectWithLanguages) => boolean
}
export const KeysForLanguagesProjectDetails = ({
  highlighted = false,
  projects = [],
  hasProjectWarning = () => false,
}: KeysForLanguagesProjectDetailsProps) => (
  <div className={clsx(styles.projects)}>
    <Card title="Activated in projects" highlighted={highlighted}>
      {projects.length ? (
        <div className={styles.projectsContainer}>
          {projects.map((project) => (
            <Tag
              className={clsx(styles.projectsTag, !!hasProjectWarning(project) && styles.warning)}
              key={project.id}
            >
              {project.name}
            </Tag>
          ))}
        </div>
      ) : (
        'Choose projects'
      )}
    </Card>
  </div>
)
